import axios from "axios";
import classNames from "classnames";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import "./App.css";
import {
  BaseData,
  BaseShelf,
  Channel,
  Content,
  EPGS,
  EPGSData,
  ItemEPGSData,
  LikesData,
} from "./globalType";

import { Header } from "./components/header";
import { Footer } from "./components/footer";
import {
  displayDuration,
  displayNumber,
  getContentUrl,
  getHost,
  translate,
} from "./utils";
import { Popup } from "./components/popup";
import { AuthContext, UserContextType } from "./auth";
import { DateTime } from "luxon";
import { TopMenu } from "./components/topMenu";
import {TailSpin} from "react-loader-spinner"

declare var $: any;

interface MainProps {
  goToPage: (page: string, content: Content | null) => void;
}

function App(props: MainProps) {
  const authContext = useContext(AuthContext);

  const { goToPage } = props;
  const [popup, setPopup] = useState<Content | null>(null);
  const [likesData, setLikesData] = useState<LikesData | null>(null)
  const [baseShelf, setBaseShelf] = useState<BaseData | null>(null)
  const [epgsData, setEPGSData] = useState<ItemEPGSData>({})
  const [liveTrigger, setLiveTrigger] = useState<boolean>(false);

  useEffect(() => {
    fetchBaseData();
    
  }, []);

  useEffect(() => {
    if (baseShelf && baseShelf.shelfs.length > 0) {
      const w_device = $(window).width();
      $('.main-slide').slick({
        infinite: true,
        dots: true,
        speed: 500,
        fade: true,
        cssEase: "linear",
        arrows: false,
      });

      $('.demo').slick({
        infinite: true,
        slidesToShow: w_device > 1200 ? 7 : w_device > 869 ? 5 : 2,
        slidesToScroll: w_device > 1200 ? 7 : w_device > 869 ? 5 : 2,

        arrows: w_device > 1200 ? true : false,

        prevArrow:
          '<img src="/ondemand/static/img/arr_left.png" class="arr-left">',
        nextArrow:
          '<button type="button" data-role="none" class="slick-next"><img src="/ondemand/static/img/arr_right.png" class="arr-right"></button>',
      });

      $('.demo-2').slick({
        infinite: true,
        slidesToShow:
          w_device > 1200 ? 4 : w_device > 869 ? 3 : w_device > 600 ? 2 : 2,
        slidesToScroll:
          w_device > 1200 ? 4 : w_device > 869 ? 3 : w_device > 600 ? 2 : 2,
        initialSlide: 3,
        arrows: w_device > 1200 ? true : false,
        prevArrow:
          '<img src="/ondemand/static/img/arr_left.png" class="arr-left">',
        nextArrow:
          '<button type="button" data-role="none" class="slick-next"><img src="/ondemand/static/img/arr_right.png" class="arr-right"></button>',
      });
    }
  }, [baseShelf])

  useEffect(() => {
    if (liveTrigger) {
      const w_device = $(window).width();
      $('.demo-2').slick('unslick');
      $('.demo-2').slick({
        infinite: true,
        slidesToShow:
          w_device > 1200 ? 4 : w_device > 869 ? 3 : w_device > 600 ? 2 : 2,
        slidesToScroll:
          w_device > 1200 ? 4 : w_device > 869 ? 3 : w_device > 600 ? 2 : 2,
        initialSlide: 3,
        arrows: w_device > 1200 ? true : false,
        prevArrow:
          '<img src="/ondemand/static/img/arr_left.png" class="arr-left">',
        nextArrow:
          '<button type="button" data-role="none" class="slick-next"><img src="/ondemand/static/img/arr_right.png" class="arr-right"></button>',
      });
    }
  }, [liveTrigger])


  const fetchBaseData = async () => {
    try {
      const result = await fetchBaseShelf();
      setBaseShelf(result.data)

      const liveChannels = result.data.shelfs.filter((c:any) => c.setting.type === 'by_livetv_channel')
      const now = DateTime.now();
      let data = {}
      for(const channel of liveChannels) {
        if (channel.shelf_items.length > 0) {
          const channel_code = channel.shelf_items.map((item: any) => item.channel_code)
          const epgsResult:any = await fetchEPGS(channel_code.join(','), now.toFormat("yyyy-LL-dd"), now.toFormat("yyyy-LL-dd"))
          
          for(const epgs of epgsResult.data) {
            const current = epgs.epgs.find((e:any) => DateTime.fromISO(e.start_date) <= now && DateTime.fromISO(e.end_date) > now)
            data = {
              ...data,
              [epgs.channel_code]: {
                channel_code: epgs.channel_code,
                epgs: current,
              },
            }
          }

        } 
        
      }
      setEPGSData(data);
      setLiveTrigger(true);
    } catch (error) {
      console.log(error);
    }
  };

  const likes = async (contentId:string | undefined) => {
    if (!contentId) return;
    if (likesData && likesData[contentId]) {
      setLikesData({
        ...likesData,
        [contentId]: false,
      })
      return;
    }
    const result = await likeContent(contentId, authContext?.user?.profile.access_token)
    if (!result) return;

    setLikesData({
      ...likesData,
      [contentId]: true,
    })
  }

  const now = DateTime.now();
  return (
    <>
      <Header goToPage={goToPage} />
      {!baseShelf && (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
        <TailSpin color="#00BFFF" height={150} width={150} />
        </div>
      )}
      
      {baseShelf && baseShelf.shelfs.map((shelf) => {
        if (!shelf.setting) return <div></div>
        if (shelf.setting.type === 'by_banner') {
          return (
            <div key={shelf.id} className="main-BG w-100">
              <div className="header-menu-BG">
                <TopMenu  menu={baseShelf.menu} goToPage={goToPage} page="foryou" />
              </div>
              <div className="main-slide">
                {shelf.shelf_items.map((b) => {
                  return <MainSlide content={b} key={b.id} goToPage={goToPage} likes={likes} likesData={likesData} menu={baseShelf.menu} />;
                })}
              </div>
            </div>
          )
        } else if (shelf.setting.type === 'by_shelfid' && shelf.shelf_items.length > 0) {
          return (
            <div key={shelf.id} className="container H-container">
              <div className="mt-4 title-BG">
                <span className="title">
                  {translate(shelf.setting.title_th, shelf.setting.title_en, authContext?.lang)}
                </span>
                <span
                  className="pink-txt pointer"
                  onClick={() => {goToPage(`/ondemand/home/${shelf.id}`, null)}}
                >
                  See More
                  <img src="/ondemand/static/img/double-right.png" alt="" />
                </span>
              </div>
              <div className="slider demo NewRelease-BG">
                {shelf.shelf_items.map((item, index) => (
                  <CarouselItem
                    goToPage={goToPage}
                    key={item.id}
                    content={item}
                    setPopup={setPopup}
                    viewType="poster"
                    index={index}
                  />
                ))}
              </div>
            </div>
          )
        } 
        else if (shelf.setting.type === 'by_topchart' && shelf.shelf_items.length > 0) {
          return (
            <div key={shelf.id} className="container H-container">
              <div className="mt-4 title-BG">
                <span className="title">
                  {translate(shelf.setting.title_th, shelf.setting.title_en, authContext?.lang)}
                </span>
                <span
                  className="pink-txt pointer"
                  onClick={() => {goToPage(`/ondemand/home/${shelf.id}`, null)}}
                >
                  See More
                  <img src="/ondemand/static/img/double-right.png" alt="" />
                </span>
              </div>
              <div className="slider demo top-BG">
                {shelf.shelf_items.map((item, index) => (
                  <CarouselItem
                    goToPage={goToPage}
                    key={item.id}
                    content={item}
                    setPopup={setPopup}
                    viewType="top"
                    index={index}
                  />
                ))}
              </div>
            </div>
          )
        } 
        else if (shelf.setting.type === 'by_tvsnow_liveview' && shelf.shelf_items.length > 0) {
          return (
            <div className="container H-container slide-BG slide-land">
          <div className="mt-4 title-BG">
            <span className="title">
            {translate(shelf.setting.title_th, shelf.setting.title_en, authContext?.lang)}
            </span>
          </div>
          <div className="slider demo-2 LiveNow-BG">
            {shelf.shelf_items
              .filter((i) => i.epgs)
              .map((content) => {
                const start = DateTime.fromISO(content.epgs?.start_date);
                const end = DateTime.fromISO(content.epgs?.end_date);

                const cls = classNames(
                  { "circle red": now >= start && now <= end },
                  { "circle white": now < start || now > end }
                );
                return (
                  <div className="pointer slide-item">
                    <div className="p-2 slide-inner">
                      <img
                        onClick={() => {
                          window.location.href = `https://tv.trueid.net/live/${content.slug}`;
                        }}
                        src={content.epgs.thumb}
                        alt="slideImg"
                      />
                      <div className="sub-BG">
                        <div className="box">
                          <div className={cls}></div>
                          Live
                        </div>
                        <p>{content.epgs.title}</p>
                        <p className="time">
                          <img
                            src="/ondemand/static/img/clock-gray.png"
                            alt="time"
                            className="mr-1"
                          />
                          {translate(
                            content.channel_info?.channel_name_th,
                            content.channel_info?.channel_name_eng,
                            authContext?.lang
                          )}{" "}
                          {start.toFormat("HH:mm")} - {end.toFormat("HH:mm")}
                        </p>
                        <img
                          src="/ondemand/static/img/play-pink.png"
                          alt="play"
                          className="play"
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
          )
        } else if (shelf.setting.type === 'by_livetv_channel' && shelf.shelf_items.length > 0) {
          const contents = shelf.shelf_items.map(item => {
            return {
              ...item,
              epgs: epgsData[item.channel_code]?.epgs,
            }
          }).filter(item => item.epgs)
          return (
            <div className="container H-container slide-BG slide-land">
          <div className="mt-4 title-BG">
            <span className="title">
            {translate(shelf.setting.title_th, shelf.setting.title_en, authContext?.lang)}
            </span>
          </div>
          <div className="slider demo-2 LiveNow-BG">
            {contents
              .map((content) => {
                const start = DateTime.fromISO(content.epgs?.start_date);
                const end = DateTime.fromISO(content.epgs?.end_date);

                const cls = classNames(
                  { "circle red": now >= start && now <= end },
                  { "circle white": now < start || now > end }
                );
                return (
                  <div className="pointer slide-item">
                    <div className="p-2 slide-inner">
                      <img
                        onClick={() => {
                          window.location.href = `https://tv.trueid.net/live/${content.slug}`;
                        }}
                        src={content.epgs.thumb}
                        alt="slideImg"
                      />
                      <div className="sub-BG">
                        <div className="box">
                          <div className={cls}></div>
                          Live
                        </div>
                        <p>{content.epgs.title}</p>
                        <p className="time">
                          <img
                            src="/ondemand/static/img/clock-gray.png"
                            alt="time"
                            className="mr-1"
                          />
                          {translate(
                            content.channel_info?.channel_name_th,
                            content.channel_info?.channel_name_eng,
                            authContext?.lang
                          )}{" "}
                          {start.toFormat("HH:mm")} - {end.toFormat("HH:mm")}
                        </p>
                        <img
                          src="/ondemand/static/img/play-pink.png"
                          alt="play"
                          className="play"
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
          )
        }
        return <div key={shelf.id}></div>
      })}

      <Popup popup={popup} goToPage={goToPage} likes={likes} likesData={likesData} />
      <Footer />
    </>
  );
}

interface CarouselItemProps {
  content: Content;
  setPopup: React.Dispatch<React.SetStateAction<Content | null>>;
  viewType: string;
  index: number;
  goToPage: (page: string, content: Content | null) => void;
}
export function CarouselItem(props: CarouselItemProps) {
  const { content, setPopup, viewType, index, goToPage } = props;
  const handlePopupChange = useCallback(() => {
    setPopup(content);
  }, [content, setPopup]);

  const w_device = $(window).width();

  const handleImageMouseEnter = useMemo(
    () => (evt: React.MouseEvent) => {
      handlePopupChange();

      let w = $(evt.target).width();
      let h = $(evt.target).height();
      let pos = $(evt.target).offset();
      let l = pos.left + w / 2 < 160 ? 160 : pos.left + w / 2;
      let per_min = (pos.left / w_device) * 100;
      let per_max = (l / w_device) * 100;

      if (per_max > 20 && per_min < 12) l = "220px";

      if ($(evt.target).attr("landscape")) {
        if (per_max > 70) {
          l = "81vw";
        }
      }

      $(".popupVideo").css({
        top: pos.top + h / 2,
        left: l,
      });

      $(".popupVideo>.detail").css({
        width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,

        height: `${h * 1.1 > 380 ? w * 1.1 : 380}px`,
      });

      if (per_max < 20 && per_min < 12) {
        $(".popupVideo").css({
          top: pos.top + h / 2,
          left: 360 / 2 + w_device * 0.04,
          right: "auto",
          width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,
          height: `auto`,
        });

        $(".popupVideo>.detail").fadeIn("100");
      } else if (per_max > 85) {
        $(".popupVideo").css({
          top: pos.top + h / 2,
          left: w_device - 360 / 2 - w_device * 0.04,
          width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,
          height: `auto`,
        });
        $(".popupVideo>.detail").fadeIn("100");
      } else {
        $(".popupVideo>.detail").hide();
        $(".popupVideo>.detail").fadeIn("100");
      }
    },
    [handlePopupChange, w_device]
  );

  let handleMouseEnter: any = () => {};
  if (w_device >= 1200) {
    handleMouseEnter = handleImageMouseEnter;
  }

  let imgSrc = content.thumb_list ? content.thumb_list?.poster: '/ondemand/static/img/default_poster.jpg'

  if (viewType === "top") {
    return (
      <div className="pointer slide-itemx">
        <div className="slide-top-BG">
          <img
            onClick={() => {
              goToPage(`/ondemand/detail/${content.id}`, content);
            }}
            src={content.thumb_list.poster}
            alt="top"
          />
          <div className="no-BG">
            <img src={`/ondemand/static/img/n${index + 1}.png`} alt="" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id={content.id} className="pointer slide-item">
      <div className="p-3">
        <img
          onClick={() => {
            goToPage(`/ondemand/detail/${content.id}`, content);
          }}
          src={imgSrc}
          alt=""
          onMouseEnter={handleMouseEnter}
        />
      </div>
    </div>
  );
}

interface CarouselChannelProps {
  content: Channel;
  setPopup: React.Dispatch<React.SetStateAction<any | null>>;
  viewType: string;
  index: number;
  epgs: EPGS | null | undefined;
}
export function CarouselChannel(props: CarouselChannelProps) {
  const { content } = props;
  const style = {
    width: "100%",
    display: "block",
    backgroundColor: "#000",
  };
  return (
    <div className="pointer slide-item">
      <div className="p-2 slide-inner">
        <picture style={style}>
          <img src={content.payload.thumb} alt="slideImg" />
        </picture>
        <div className="sub-BG">
          <div className="box">True visions</div>
          <p>{content.title}</p>
        </div>
      </div>
    </div>
  );
}

interface MainSlideProps {
  content: Content;
  goToPage: (page: string, content: Content | null) => void;
  likes: (contentId: string) => void;
  likesData: LikesData | null;
  menu: BaseShelf[];
}
function MainSlide(props: MainSlideProps) {
  const { content, goToPage, likes, likesData, menu } = props;
  const w_device = $(window).width();
  let bgImg = content.thumb_list.landscape_image;
  if (w_device < 1200) {
    bgImg = content.thumb_list.square_image;
  }
  if (w_device < 600) {
    bgImg = content.thumb_list.portrait_image;
  }
  const style = {
    backgroundImage: `url('${bgImg}')`,
    backgroundPosition: 'center',
  };

  let likeCls = ''
  if (likesData && content) {
    likeCls = classNames({'active': likesData[content.id]})
  }

  return (
    <div className="banner-BG" style={style}>
      <div className="g-BG"></div>
      <div className="container H-container">
        <div className="inner">
          <div className="body-detail">
            <div className="type-BG">{content.genres?.join(",")}</div>
            <div className="rating">
              <img src="/ondemand/static/img/start.png" alt="" />
              <img src="/ondemand/static/img/start.png" alt="" />
              <img src="/ondemand/static/img/start.png" alt="" />
              <img src="/ondemand/static/img/start.png" alt="" />
              <img src="/ondemand/static/img/start.png" alt="" />
            </div>
            <div className="detail">
              <h1>{content.title}</h1>
              <p className="mt-4 inline-p">
                <img
                  src="/ondemand/static/img/d-video.png"
                  alt=""
                  className="mr-2"
                />
                {displayDuration(content.duration)}
                <img
                  src="/ondemand/static/img/d-play.png"
                  alt=""
                  className="ml-3 mr-2"
                />
                {displayNumber(content.count_views)}
                <img
                  src="/ondemand/static/img/d-like.png"
                  alt=""
                  className="ml-3 mr-2"
                />
                {displayNumber(content.count_likes)}
                <span className="ml-3 pink-txt web mr-2">Audio : </span>
                <span className="web">{content.audio?.join(", ")}</span>
                <span className="ml-3 pink-txt web mr-2">Subtitle : </span>
                <span className="web">{content.subtitle?.join(", ")}</span>
              </p>
              <p className="web">{content.description}</p>
            </div>
            <div className="action-BG">
            <button
                onClick={() => {
                  window.location.href = getContentUrl(content);
                }}
              >
                <img
                  src="/ondemand/static/img/play-white-l.png"
                  alt=""
                  className="mr-3"
                />
                Watch now
              </button>
              <button
                onClick={() => {
                  goToPage(`/ondemand/detail/${content.id}`, content);
                }}
              >
                <img src="/ondemand/static/img/info-l.png" alt="" />
              </button>
              <button className={likeCls} onClick={() => {likes(content.id)}}>
                <img src="/ondemand/static/img/like-l.png" alt="" />
              </button>
              <button>
                <img src="/ondemand/static/img/share-l.png" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

async function fetchBaseShelf() {
  const host = getHost();
  return axios.get(`${host}/api/series-base-shelf`);
}

async function fetchEPGS(
  channel_code: string,
  start_date: string,
  end_date: string
) {
  const host = getHost();
  return axios.get(
    `${host}/api/my-channels-epg?channel_code=${channel_code}&start_date=${start_date}&end_date=${end_date}`
  );
}

async function likeContent(
  contentId: string,
  access_token: string | undefined
) {
  if (!access_token) return null
  const host = getHost();
  return axios.get(
    `${host}/api/likes/${contentId}?access_token=${access_token}`
  );
}

export default App;
